import { render, staticRenderFns } from "./reelInstagram.vue?vue&type=template&id=6581b49f"
import script from "./reelInstagram.vue?vue&type=script&lang=js"
export * from "./reelInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6581b49f')) {
      api.createRecord('6581b49f', component.options)
    } else {
      api.reload('6581b49f', component.options)
    }
    module.hot.accept("./reelInstagram.vue?vue&type=template&id=6581b49f", function () {
      api.rerender('6581b49f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/reelInstagram.vue"
export default component.exports